import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { DialogFileUploadComponent } from "src/app/components/shared/dialog/file-upload.component";
import { SvgMatType } from "src/app/constants/icons";
import { TableColumnType } from "src/app/constants/table";
import { BenefitCheckoutWizardPanel } from "src/app/constants/wizard-panels";
import { DependentGridList, DependentGridVerifyDetail } from "src/app/models/dependent-grid";
import { FileUploadDialogModel } from "src/app/models/dialog";
import { CheckoutDependents } from "src/app/models/enrollment-checkout";
import { TableColumn } from "src/app/models/table";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-dependent-verify',
    templateUrl: './dependent-verify.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutDependentVerifyComponent implements OnInit {
    @Input() public checkoutDependents: CheckoutDependents;
    
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public depedentMatTableData: MatTableDataSource<DependentGridVerifyDetail>;
    public depedentTableColumns: TableColumn[] = [ 
        {
            columnName: 'Name',
            propertyId: 'dependentName',
            columnType: TableColumnType.labelAndToolTip,
            svgCustomName: SvgMatType.SmsFailed,
            toolTip: 'disabledMessage',
            toolTipCSS: 'error',
            toolTipDisplayEnd: true,
        },
        {
            columnName: 'Relationship',
            propertyId: 'dependentRelationship',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Documents Status',
            propertyId: 'verifcationStatus',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Upload Documents',
            propertyId: 'dependentID',
            columnType: TableColumnType.button,
            dataTypeText: 'Upload',
        }
    ];

    constructor(
        private helperService: HelperService,
        private dialog: MatDialog,
        private enrollmentManagerService: EnrollmentManagerService
    ) {
    }

    ngOnInit(): void {
        const l_DependentGridVerifyDetails: DependentGridVerifyDetail[] = [];
        this.checkoutDependents.dependents.forEach((d: DependentGridList ) => {
            const l_DependentGridVerifyDetail = this.helperService.convertObjectIntoObject(d, new DependentGridVerifyDetail());
            if (d.dependentIsVerified || d.dependentIsVerifiedIsPending) {
                l_DependentGridVerifyDetail.verifcationStatus = d.dependentIsVerifiedIsPending ? 'Awaiting Administrator Review' : 'Successfully Verified';
            } else {
                l_DependentGridVerifyDetail.verifcationStatus = '* Requires Documents *';
                l_DependentGridVerifyDetail.requiresDocuments = true;
            }

            l_DependentGridVerifyDetails.push(l_DependentGridVerifyDetail);
        });
        this.depedentMatTableData = new MatTableDataSource<DependentGridVerifyDetail>();
        this.depedentMatTableData.data = l_DependentGridVerifyDetails;
    }

    public openUploadDocumentDialog(eventValue: DependentGridVerifyDetail): void {
        const l_FileUploadDialogModel = new FileUploadDialogModel();
        l_FileUploadDialogModel.dependentId = eventValue.dependentID;
        l_FileUploadDialogModel.dependentRelationship = eventValue.dependentRelationship;
        l_FileUploadDialogModel.memberName = eventValue.dependentName;
        l_FileUploadDialogModel.wizardType = this.enrollmentManagerService.manager.BenefitWizardType;
        l_FileUploadDialogModel.panelName = BenefitCheckoutWizardPanel.dependentVerify;
        const dialogRef = this.dialog.open(DialogFileUploadComponent, { data: l_FileUploadDialogModel, panelClass: 'mwp-modal-override-1000' });
        
        // dialogRef.afterClosed().subscribe((response: DependentGridList[]) => {
        //     // if (response) {
        //     //     this.dependents = response;
        //     // }
        // });

    }

    public complete(): void {

        this.emitComplete.emit();
    }
}